import { render, staticRenderFns } from "./UserFeedback.vue?vue&type=template&id=45ec5460&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"
import style0 from "./UserFeedback.vue?vue&type=style&index=0&id=45ec5460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec5460",
  null
  
)

export default component.exports